module.exports = __webpack_public_path__ + "static/img/fireWater.25f18f6c.png";